import CreditCardIcon from "@mui/icons-material/Payment";
import ApplePayIcon from "images/apple-pay.svg?react";
import GooglePayIcon from "images/google-pay.png";
import { PaymentMethod } from "services/paymentMethods";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";

interface Props {
  paymentMethod: PaymentMethod;
  className?: string;
}

export default function PaymentMethodIcons({ paymentMethod, className }: Props) {
  const { t } = useTranslation();

  switch (paymentMethod.wallet?.type) {
    case "apple_pay":
      return <ApplePayIcon className={classNames(styles.defaultIcon, className)} />;
    case "google_pay":
      return (
        <img
          src={GooglePayIcon}
          alt={t("Common.paymentMethodIcons.googlePayAlt")}
          className={classNames(styles.defaultIcon, className)}
        />
      );
    default:
      return <CreditCardIcon className={classNames(styles.defaultIcon, className)} />;
  }
}
